module.exports = __webpack_public_path__ + "img/mobile-responsive.106da9c5.svg";